/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-05-17T10:46:25.411
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getEvaluateAppointmentKeeprecordEditInit,
	getEvaluateAppointmentKeeprecordView
} from '@api/storagemanage/EvaluateAppointmentKeeprecord';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getEvaluateAppointmentKeeprecordEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEvaluateAppointmentKeeprecordEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getEvaluateAppointmentKeeprecordView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getEvaluateAppointmentKeeprecordView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
